<template>
    <div>
        <el-dialog :title="$tx('hygl.components.meetingDetail', '会议详情')" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px" :before-close="handleClose" :append-to-body="true">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="$tx('hygl.components.meetingInfo', '会议信息')" name="first">
                    <el-form :model="vo">
                        <div class="el-table el-table--fit el-table--border">
                            <div class="el-table__body-wrapper">
                                <table cellspacing="0" cellpadding="0" class="el-table__body">
                                    <tbody>
                                        <tr>
                                            <td v-field-lbl="'flSubject'" class="el-table__cell tdlbl tdw17" colspan="1">会议主题</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flSubject }}</span>
                                            </td>
                                            <td v-field-lbl="'meetingName'" class="el-table__cell tdlbl tdw17" colspan="1">会议室名称</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.meetPlace }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'startTime'" class="el-table__cell tdlbl tdw17" colspan="1">开始时间</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.startTime }}</span>
                                            </td>
                                            <td v-field-lbl="'endTime'" class="el-table__cell tdlbl tdw17" colspan="1">结束时间</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.endTime }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'flCreator'" class="el-table__cell tdlbl tdw17" colspan="1">召集人</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flCreator }}</span>
                                            </td>
                                            <td v-field-lbl="'flCreateDept'" class="el-table__cell tdlbl tdw17" colspan="1">召集部门</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flCreateDept }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-text-lbl="'phone'" class="el-table__cell tdlbl tdw17" colspan="1">联系电话</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.flCreatorPhone }}</span>
                                            </td>
                                            <td v-field-lbl="'meetHost'" class="el-table__cell tdlbl tdw17" colspan="1">会议主持人</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ vo.meetHost }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td v-field-lbl="'attendLeader'" class="el-table__cell tdlbl tdw17" colspan="1">出席领导</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <span>{{ vo.attendLeader }}</span>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td ref="tdlbl_会议主题" v-field-lbl="'flContent'" class="el-table__cell tdlbl tdw17" colspan="1">会议内容</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <span>{{ vo.flContent }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td ref="tdlbl_会议主题" v-field-lbl="'meetingAttach'" class="el-table__cell tdlbl tdw17" colspan="1">会议附件</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <div v-for="item in attachs" :key="item">
                                                    <span class="hoverSpan" style="cursor: pointer; color: #409efe" @click="downloadFuc(item.id)">{{ item.fileName }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.meetingAgenda', '会议议题')" name="second">
                    <!-- <p style="width: 96%; margin: 0 2%;"><span style="float: left;margin-bottom:10px ;">会议议题</span></p> -->
                    <el-table border :data="tableData" style="margin-bottom: 20px" height="300px">
                        <!-- :on-cell-click="rowClick" -->
                        <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                        <el-table-column :label="$tx('hygl.components.topics', '议题')" align="left" prop="subject" />
                        <el-table-column :label="$tx('hygl.components.reporter', '汇报人')" align="left" width="80" prop="reportPersonName" />
                        <el-table-column :label="$tx('hygl.components.reportTime', '汇报时长(分钟)')" align="center" width="110" prop="reportTime" />
                        <el-table-column :label="$tx('hygl.components.durationTime', '讨论时长(分钟)')" align="center" width="110" prop="talkTime" />
                        <el-table-column :label="$tx('hygl.components.attendees', '列席人员')" align="left" width="200" prop="attendStoolName" />
                        <el-table-column :label="$tx('hygl.components.attachNum', '附件数量')" width="100" align="center">
                            <template #default="scope">
                                <span style="cursor: pointer" @click="downloadFucYt(scope.row.id, scope.row.passenger.ytNum)">{{ scope.row.passenger.attachments.length }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.meetinger', '会议人员')" name="third" class="hyryBox">
                    <!-- <p style="width: 96%; margin: 0 2%;"><el-button size="small" :disabled="(resultobj.meetStatus === 0&&resultobj.openApply === 1)?false :true" style="float: right;margin-bottom:10px" @click="innerVisible = true">添加人员</el-button></p> -->
                    <el-table v-model="tableDataPeople" border :data="tableDataPeople" style="margin-bottom: 20px; border-bottom: 1px solid #ebeef5" height="350px">
                        <!-- style="width: 96%;margin: 0 2%;height: 310px;overflow: hidden;overflow-y: auto;" -->
                        <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                        <el-table-column :label="$tx('fields.name', '姓名')" align="left" prop="userName" />
                        <el-table-column :label="$tx('hygl.components.duties', '职务')" width="100" align="left" prop="userPost" />
                        <el-table-column :label="$tx('hygl.components.depart', '部门')" width="100" align="left" prop="userDept" />
                        <el-table-column :label="$tx('hygl.components.phone', '联系电话')" width="100" align="center" prop="phone" />
                        <el-table-column :label="$tx('hygl.components.personType', '人员类型')" width="100" align="center" prop="meetPersonType">
                            <template #default="scope">
                                <span v-if="scope.row.meetPersonType === 1" v-text-lbl="'insider'">内部人员</span>
                                <span v-if="scope.row.meetPersonType === 2" v-text-lbl="'outsiders'">外部人员</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$tx('fields.remark', '备注')" align="left" width="100" prop="remark" />
                    </el-table>
                    <!-- <el-table-column
              v-if="(resultobj.meetStatus === 0&&resultobj.openApply === 1)"
              :label="$tx('pageBtns.operate','操作')"
              width="65"
              align="center"
            >
              <template v-slot="scope">
                <span style="cursor: pointer;color: #409EFE;" font-size="20px" @click="delChecked(scope.$index,scope.row)"> {{ $tx('hygl.common.del') }} </span>
              </template>
            </el-table-column>
          </el-table> -->
                    <el-dialog width="600px" :title="$tx('hygl.components.participants', '参会人员')" :visible.sync="innerVisible" append-to-body>
                        <el-form :model="voPeople">
                            <div class="el-table el-table--fit el-table--border">
                                <div class="el-table__body-wrapper">
                                    <table cellspacing="0" cellpadding="0" style="border: 1px solid #ebeef5" class="el-table__body">
                                        <tbody>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    是否参会
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="是否参会" rules="required">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-radio-group v-model="addObj.regStatus">
                                                                <el-radio :label="1">是</el-radio>
                                                                <el-radio :label="2">否</el-radio>
                                                            </el-radio-group>
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    <span v-text-lbl="'personType'">类型</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="人员类型" rules="required">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-select v-model="addObj.meetPersonType" style="width: 100%" placeholder="">
                                                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                                                            </el-select>
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    <span v-field-lbl="'name'">姓名</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="姓名" rules="required">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-input v-model="addObj.userName" v-select-dialog="'staff'" :readonly="addObj.meetPersonType == '1'" type="textarea" :row="2" :root-org-code="vo.orgCode" :placeholder="$tx('hygl.components.orgPlaceholder', '请选择机构员工')" name="orgStaff" resize="none" />
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    <span v-text-lbl="'telphone'">电话</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <el-input v-model="addObj.phone" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    <span v-text-lbl="'position'">职位</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <el-input v-model="addObj.userPost" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span class="required">*</span>
                                                    <span v-text-lbl="'depart'">部门</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <el-input v-model="addObj.userDept" />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">
                                                    <span v-if="addObj.regStatus === 0" class="required">*</span>
                                                    <span v-text-lbl="'remark'">备注</span>
                                                </td>
                                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                                    <el-input v-model="addObj.remark" type="textarea" :rows="2" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button v-pageBtn-lbl="'cancel'" @click="innerVisible = false">取消</el-button>
                            <el-button v-pageBtn-lbl="'save'" type="primary" @click="savePeopleFuc">保 存</el-button>
                        </span>
                    </el-dialog>
                    <!-- </el-table> -->
                </el-tab-pane>
                <el-tab-pane :label="$tx('hygl.components.meetingMinutes', '会议记录')" name="fourth">
                    <!-- <div style="width:100%;height: 350px;padding: 10px;overflow:hidden;overflow-y:hidden;border: 1px solid rgb(235, 238, 245);">{{ vo.meetRecord ===null?'暂无记录':vo.meetRecord }}</div> -->
                    <div class="textW" style="width: 100%; height: 350px; padding: 10px; overflow: hidden; overflow-y: hidden; border: 1px solid rgb(235, 238, 245)">
                        <span v-if="!showRecord">{{ vo.meetRecord }}</span>
                        <el-input v-else v-model="vo.meetRecord" type="textarea" :rows="2" placeholder="请输入会议记录" />
                    </div>
                </el-tab-pane>
                <el-tab-pane v-if="getzhuanpai !== null" label="转派记录" name="zhuanpai">
                    <el-form :model="getzhuanpai">
                        <div class="el-table el-table--fit el-table--border">
                            <div class="el-table__body-wrapper">
                                <table cellspacing="0" cellpadding="0" class="el-table__body">
                                    <tbody>
                                        <tr>
                                            <td class="el-table__cell tdlbl tdw17" colspan="1">转派人</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ getzhuanpai.turnsendName }}</span>
                                            </td>
                                            <td class="el-table__cell tdlbl tdw17" colspan="1">转派时间</td>
                                            <td class="el-table__cell tdcont tdw33" colspan="2">
                                                <span>{{ getzhuanpai.turnsendTime }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td ref="tdlbl_会议主题" class="el-table__cell tdlbl tdw17" colspan="1">转派原因</td>
                                            <td class="el-table__cell tdcont tdw83" colspan="5">
                                                <span>{{ getzhuanpai.tsReason }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="showRecord" v-pageBtn-lbl="'save'" type="primary" @click="subSave">保 存</el-button>
                <el-button v-pageBtn-lbl="'close'" plain @click="dialogVisible = false">关 闭</el-button>
                <!-- <el-button icon="el-icon-close" @click="dialogVisible = false" v-pageBtn-lbl="'close'" >关 闭</el-button> -->
            </span>
        </el-dialog>
        <!-- 点击会议议题 -->
        <el-dialog v-if="ytisShow" v-el-drag-dialog title="附件" :visible.sync="ytisShow" :close-on-click-modal="false" width="1000px">
            <el-table border :data="listData" style="margin-bottom: 20px; cursor: pointer" @row-click="rowClickyit">
                <!-- :on-cell-click="rowClick" -->
                <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                <el-table-column :label="$tx('hygl.components.fileName2', '文件名称')" align="left">
                    <template slot-scope="scope">
                        <div style="color: #409eff">{{ scope.row.fileName }}</div>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" icon="el-icon-close" @click="ytisShow = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            activeName: 'first',
            attachs: null,
            tableData: [],
            tableDataPeople: [],
            dialogVisible: false,
            vo: {},
            meetingId: '',
            radio: 1,
            innerVisible: false,
            options: [
                {
                    value: '1',
                    label: this.$tx('hygl.components.participants', '参会人员')
                },
                {
                    value: '2',
                    label: this.$tx('hygl.components.liaisonMan', '联络员')
                }
            ],
            value: '',
            resultobj: {},
            addObj: {
                regStatus: 1,
                meetPersonType: '1',
                remark: '',
                email: '',
                passenger: {},
                personId: '',
                userAccount: ''
            },
            ytisShow: false,
            showRecord: false,
            listData: [],
            loginUser: this.$store.getters.loginUser,
            listfujian: [], // 保存附件
            getzhuanpai: null
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {
        this.$bus.$off('clicklog')
    },
    mounted() {
        const _this = this
        this.$bus.$on('clicklog', (resultobj) => {
            _this.showRecord = false
            if (_this.loginUser.personName === resultobj.flCreator) {
                if (resultobj.meetStatus === 1 || resultobj.meetStatus === 2) {
                    _this.showRecord = true
                } else {
                    _this.showRecord = false
                }
            }
            this.resultobj = resultobj
            this.activeName = 'first'
            this.dialogVisible = true
            this.meetingId = resultobj.id
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    busiDataIds: resultobj.id
                },
                url: '/hygl/attach/queryAttachList'
            }).then((result) => {
                if (result.code === 'success') {
                    this.attachs = result.body.listdata
                    console.log(this.attachs)
                } else {
                    this.$message.error(result.message)
                }
            })
            this.vo = {}
            this.initGetById(resultobj.id)
            this.getHyyt(resultobj.id)
        })
    },
    methods: {
        subSave() {
            console.log(this.vo.meetRecord, this.meetingId)
            this.$http({
                url: '/hygl/hyap/updateMeetRecord',
                method: 'PUT',
                params: {
                    meetRecord: this.vo.meetRecord,
                    id: this.meetingId
                }
            }).then((res) => {
                console.log(res, 466)
                if (res.code === 'success') {
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                    this.dialogVisible = false
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 下载议题附件
        downloadFucYt(id, num) {
            if (num > 0) {
                var attachurl = process.env.VUE_APP_BASE_API + '/hygl/ytap/downloadByBusiDataId?busiDataId=' + id + '&httpPort=' + location.port
                window.open(attachurl, '_blank')
            }
        },
        // 下载会议题件
        downloadFuc(id, num) {
            var attachurl = process.env.VUE_APP_BASE_API + '/hygl/hyap/downloadById?attachIds=' + id + '&httpPort=' + location.port
            window.open(attachurl, '_blank')
        },
        // 添加人员
        async savePeopleFuc() {
            const res = await this.$app.insert('/hygl/meetPeople/insert', this.addObj)
            if (res.code === 'success') {
                this.$message.success(res.message)
                this.innerVisible = false
                this.getPeople()
                this.getzhuanpais()
                this.addObj = {}
            } else {
                this.$message.error(res.message)
                this.innerVisible = false
            }
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += '、'
                selected = node
            })
            const num = selected.title.indexOf('\\')
            const dept = selected.title.substring(0, num)
            this.$set(this.addObj, 'userName', selected.name)
            this.$set(this.addObj, 'phone', selected.mobile)
            this.$set(this.addObj, 'userPost', selected.positionName)
            this.$set(this.addObj, 'userDept', dept)
            this.$set(this.addObj, 'email', selected.email)
            this.$set(this.addObj, 'userAccount', selected.account)
            this.$set(this.addObj, 'personId', selected.personId)
            this.$set(this.addObj, 'meetId', this.meetingId)
        },
        // tab切换
        handleClick(tab, event) {
            console.log(tab, event)
            if (tab.name === 'third') {
                this.getPeople()
            }
            if (tab.name === 'zhuanpai') {
                this.getzhuanpais()
            }
        },
        // 点击议题附件
        rowClickyit(row) {
            if (row.id) {
                var attachurl = process.env.VUE_APP_BASE_API + '/hygl/hyap/downloadById?attachIds=' + row.id + '&httpPort=' + location.port
                window.open(attachurl, '_blank')
                // var attachurl = process.env.VUE_APP_BASE_API + '/hygl/hyap/downloadByBusiDataId?busiDataId=' + row.id + '&httpPort=' + location.port
                // window.open(attachurl, '_blank')
            }
            // let downUrl = process.env.VUE_APP_BASE_API + '/' + this.wfAttachUrl + '/downloadById?inline=true&attachIds=' + row.id
            // downUrl += '&httpPort=' + location.port
            // window.open(downUrl)
            console.log('点击行', row)
        },
        async initGetById(resultobj) {
            const res = await this.$app.getById('/hygl/hyap/getById', resultobj)
            if (res.code === 'success') {
                this.vo = res.body.vo
                this.getzhuanpais()
            } else {
                this.$message.error(res.message)
            }
        },
        getHyyt(id) {
            this.$app
                .listdata('/hygl/hyapYtInfo/listdata', {
                    pageNum: 1,
                    pageSize: 1000,
                    urlsearch: 'hyapId:' + id
                })
                .then((res) => {
                    if (res.code === 'success') {
                        this.tableData = res.body.pageInfo.list
                    }
                })
        },
        // 获取参会人员
        async getPeople() {
            const search = [
                {
                    compare: '=',
                    field: 'meetId',
                    merge: true,
                    value: this.meetingId
                }
            ]
            const res = await this.$app.querydata('/hygl/meetPeople/querydata', search, 'orgFullOrderNo asc')
            if (res.code === 'success') {
                this.tableDataPeople = res.body.listdata
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取转派记录
        async getzhuanpais() {
            const search = [
                {
                    compare: '=',
                    field: 'meetId',
                    merge: true,
                    value: this.meetingId
                }
                // {
                //     compare: '=',
                //     field: 'personId ',
                //     merge: true,
                //     value: this.vo.personId
                // },
                // {
                //     compare: '=',
                //     field: 'regStatus',
                //     merge: true,
                //     value: 3
                // }
            ]
            const res = await this.$app.querydata('/hygl/meetPeople/querydata', search, 'orgFullOrderNo asc')
            if (res.code === 'success') {
                // this.tablezhuanpai = res.body.listdata
                for (let i = 0; i < res.body.listdata.length; i++) {
                    if (res.body.listdata[i].regStatus === 3 || res.body.listdata[i].regStatus === '3') {
                        this.getzhuanpai = res.body.listdata[i]
                    }
                }
            } else {
                this.$message.error(res.message)
            }
        },
        // 删除参会人员
        async delChecked(index, row) {
            const arrIds = []
            arrIds.push(row.id)
            console.log(arrIds)
            const res = await this.$app.deleteByIds('/hygl/meetPeople/delete', arrIds)
            if (res.code === 'success') {
                this.$message.success(res.message)
                this.getPeople()
                this.getzhuanpais()
            } else {
                this.$message.error(res.message)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.el-dialog .el-dialog__body .el-tabs--top {
    margin-top: 0;
    height: 400px;
}
/deep/.el-table .el-textarea__inner {
    height: 36px;
}
/deep/.el-tabs__content::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
}
/deep/.el-tabs__content {
    height: 361px;
    overflow-y: auto;
}
.hoverSpan:hover {
    color: #409eff;
}
.hyryBox {
    /deep/ .el-table::before {
        content: none;
    }
}
.textW {
    /deep/.el-input {
        min-height: 328px !important;
    }
}
</style>
